export const PATH = 'api/landlord/team/settings';